import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { ScrollView, View } from 'native-base';
import React from 'react';

import { CockpitSectionBlockingMismatchedPartner } from '../Cockpit/components/CockpitSectionBlockingMismatchedPartner';

import { Customer } from './components/Customer';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Product } from './components/Products';

export const ContainerWrapper = ({ children }) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  if (isDesktop) {
    return (
      <VStack pb={Spacing['inline.nano']} space={Spacing['inline.xxs']}>
        {children}
      </VStack>
    );
  }

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      px={Spacing['inline.xxxs']}
      pb={Spacing['inline.nano']}>
      <VStack space={Spacing['inline.xxs']}>{children}</VStack>
    </ScrollView>
  );
};

export const BatchTicket = () => {
  const Wrapper = useBreakpointValue({
    base: ({ children }) => <View minW="container">{children}</View>,
    lg: ({ children }) => (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View minW="container">{children}</View>
      </ScrollView>
    ),
  });

  return (
    <Wrapper>
      <ContainerWrapper>
        <Header />
        <Customer />
        <Product />
      </ContainerWrapper>
      <Footer />
      <CockpitSectionBlockingMismatchedPartner />
    </Wrapper>
  );
};
